import {
  ResourcePairField,
  ResourcePairFieldProps,
} from './_components/ResourcePairField';

export const OverheadField = ({
  LabelComponent,
}: Pick<ResourcePairFieldProps, 'LabelComponent'>) => {
  return (
    <ResourcePairField
      LabelComponent={LabelComponent}
      size="medium"
      variant="percentage"
      testId="overhead-field"
    />
  );
};
